import React from 'react';
import {connect} from 'react-redux';
import {DebugHeader} from './DebugHeader';
import {DebugUserInfoView} from './DebugUserInfoView';
import {DebugUserPurchasesView} from './DebugUserPurchasesView';
import {DebugUserClientPurchasesView} from './DebugUserClientPurchasesView';
import {DebugWebUserView} from './DebugWebUserView';
import {bindActionCreators} from 'redux';
import {searchPurchasesEvents, searchUsers, searchWebUsers} from '../../../actions/qa';

const QADebug = ({
  users, isLoadingUsers,
  purchaseEvents, clientPurchaseEvents, isLoadingPurchasesEvents,
  webUsers, isLoadingWebUsers,
  searchUsers, searchPurchasesEvents, searchWebUsers,
}) => {
  return (
    <div className={'qa-container'}>
      <DebugHeader
        search={(deviceId) => {
          if (deviceId && deviceId.length !== 0) {
            searchUsers(deviceId);
            searchPurchasesEvents(deviceId);
          }
        }}
        searchByEmail={(email) => {
          if (email && email.length !== 0) {
            searchWebUsers(email);
          }
        }}
      />
      <DebugUserInfoView
        users={users}
        isLoadingUsers={isLoadingUsers}
      />
      <DebugUserPurchasesView
        purchaseEvents={purchaseEvents}
        isLoadingPurchasesEvents={isLoadingPurchasesEvents}
      />
      <DebugUserClientPurchasesView
        purchasesEvents={clientPurchaseEvents}
        isLoadingPurchasesEvents={isLoadingPurchasesEvents}
      />
      <DebugWebUserView
        webUsers={webUsers}
        isLoadingWebUsers={isLoadingWebUsers}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  users: state.qa.users,
  isLoadingUsers: state.qa.isLoadingUsers,
  purchaseEvents: state.qa.purchaseEvents,
  clientPurchaseEvents: state.qa.clientPurchaseEvents,
  isLoadingPurchasesEvents: state.qa.isLoadingPurchasesEvents,
  webUsers: state.qa.webUsers,
  isLoadingWebUsers: state.qa.isLoadingWebUsers,
});

const mapDispatchToProps = (dispatch) => ({
  searchUsers: bindActionCreators(searchUsers, dispatch),
  searchPurchasesEvents: bindActionCreators(searchPurchasesEvents, dispatch),
  searchWebUsers: bindActionCreators(searchWebUsers, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(QADebug);
